import { render } from "./Duobao.vue?vue&type=template&id=3d67790c&scoped=true"
import script from "./Duobao.vue?vue&type=script&lang=js"
export * from "./Duobao.vue?vue&type=script&lang=js"

import "./Duobao.vue?vue&type=style&index=0&id=3d67790c&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d67790c"]])

export default __exports__